import { render, staticRenderFns } from "./BranchSection.vue?vue&type=template&id=093fbe7a&scoped=true"
import script from "./BranchSection.vue?vue&type=script&lang=js"
export * from "./BranchSection.vue?vue&type=script&lang=js"
import style0 from "./BranchSection.vue?vue&type=style&index=0&id=093fbe7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093fbe7a",
  null
  
)

export default component.exports